"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pickBy = _interopRequireDefault(require("lodash-es/pickBy"));

var _utils = require("../lib/utils");

require("./badge.css");

/* eslint-disable react/jsx-fragments */
var getClonedIcon = function getClonedIcon(icon) {
  var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "left";

  if ( /*#__PURE__*/_react["default"].isValidElement(icon)) {
    return /*#__PURE__*/_react["default"].cloneElement(icon, {
      className: (0, _utils.gatherClasses)(null, "oui-label-".concat(align, "-icon"), icon.props.className)
    });
  }

  return null;
};

var isValidBadgeVariant = function isValidBadgeVariant(variant) {
  var _context;

  return (0, _includes["default"])(_context = ["success", "warning", "danger"]).call(_context, variant);
};

var getLabelNode = function getLabelNode(label) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "oui-label-text"
  }, label);
};

var Badge = function Badge(props) {
  var dataTestId = props.dataTestId,
      clickable = props.clickable,
      label = props.label,
      _onClick = props.onClick,
      icon = props.icon,
      alignIcon = props.alignIcon,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      active = props.active,
      variant = props.variant;
  var color = style.color,
      backgroundColor = style.backgroundColor;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, "oui-badge", clickable ? "oui-clickable" : "", active ? "oui-border-primary" : "", isValidBadgeVariant(variant) ? "oui-badge-variant-".concat(variant, " oui-variant") : ""),
    style: isValidBadgeVariant(variant) ? {} : (0, _pickBy["default"])({
      color: color,
      backgroundColor: backgroundColor
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _utils.gatherClasses)(null, "oui-badge-label", "oui-text-truncate", icon && "oui-badge-with-icon")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _utils.gatherClasses)(null, (0, _utils.isFunction)(_onClick) ? "oui-pointer" : "", clickable ? "oui-clickable" : ""),
    onClick: function onClick(e) {
      if ((0, _utils.isFunction)(_onClick)) {
        _onClick(props, e);
      }
    },
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, alignIcon === "left" && getClonedIcon(icon, "left"), getLabelNode(label), alignIcon === "right" && getClonedIcon(icon, "right")))));
};

Badge.propTypes = {
  label: _propTypes["default"].string.isRequired,
  clickable: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  style: _propTypes["default"].shape({
    color: _propTypes["default"].string,
    backgroundColor: _propTypes["default"].string
  }),
  dataTestId: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  alignIcon: _propTypes["default"].oneOf(["left", "right"]),
  active: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(["success", "danger", "warning"])
};
Badge.defaultProps = {
  clickable: true,
  onClick: null,
  dataTestId: "orion-badge",
  alignIcon: "left",
  active: false
};
Badge.displayName = "OrionBadge";
var _default = Badge;
exports["default"] = _default;